import React, { Fragment } from 'react';

import { connect } from 'react-redux';

import { AppState, IPageState } from '../../appredux';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';



import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
import './../../components/DataGrid.css';

import theme from '../../themes';
import { CellProps } from '@inovua/reactdatagrid-community/Layout/ColumnLayout/Cell/CellProps';

import SearchIcon from '@material-ui/icons/Search';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';



import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { TransProps, withTranslation, WithTranslation } from 'react-i18next';
import { KarnetZjazdy } from 'api';
import { daysFromDate } from 'common/helpers';
import { DARK_TEXT_COLOR, DARK_TEXT_TABLE_COLOR } from 'App';

interface TabelaZaplatyProps extends WithStyles<typeof styles> {
    page: IPageState,
    tableBody: KarnetZjazdy[],
    icon?: boolean;
    select: (cell: KarnetZjazdy) => void,
  
    

}

interface TabelaZaplatyState {
    ukryteKolumny: string[],
}

class TabelaZaplaty extends React.Component<TabelaZaplatyProps & WithTranslation & TransProps, TabelaZaplatyState>  {

    //PM 2021-09-17
    constructor(props: TabelaZaplatyProps & WithTranslation & TransProps) {
        super(props, {});
        this.state = {
            ukryteKolumny: [],
        }

    }

    //PM 2021-10-20
    dajFontAkcjaOpis = () => {
        if (window.innerWidth <= 1366)
            return '6px';
        else if (window.innerWidth <= 1600)
            return '9px';
        else
            return '10px';
    }

    //PM 2021-10-20
    dajFontOpis = () => {
        if (window.innerWidth <= 600)
            return '9px';
        else if (window.innerWidth <= 1366)
            return '10px';
        else
            return '12px';
    }

    cellRender = ({ value, data, cellProps }: any) => {
        const { classes } = this.props;
        let tablet = this.props.page.tablet
        let val = value

        let dateNow = daysFromDate(new Date(), 0)

        let fontWeight = cellProps.name === 'lockAlias' || cellProps.name === 'doWyslaniaIlosc' ? 'bold' : 'normal'; 

        if(data.dt.slice(0, 10) === dateNow){
            fontWeight = "bold"
        }
        
        let color = theme.palette.primary.main;
        if(!this.props.page.lightMode) color = DARK_TEXT_TABLE_COLOR
        if (data.typ === "2" || data.typ === "5")  {
            color = theme.palette.text.secondary;
        }
        if (data.typ === "3" || data.typ === "6")  {
            color = theme.palette.error.main;
        }


        if (cellProps.name === 'dt') {
            val = data.dt.split(" ")[0]
        }
        if (cellProps.name === 'godzina') {
            val = data.dt.split(" ")[1].slice(0, 5)
        }

        let today = daysFromDate(new Date, 0)    
        let yesterday = daysFromDate(new Date, -1)    
        if(cellProps.name === 'dt' && value.slice(0, 10) === today){
            val = "dzisiaj " //+ value.slice(10, 16)
        }
        if(cellProps.name === 'dt' && value.slice(0, 10) === yesterday){
            val = "wczoraj " //+ value.slice(10, 16)
        }

        
        if(cellProps.columnIndex === 3){ //cellProps.columnIndex === 9 - this.state.ukryteKolumny.length
            return (
                <Fragment>
                    <Tooltip title="zdjęcie" classes={{tooltip: classes.tooltip}}>
                        <IconButton style={{ padding: '4px' }}>
                            <PhotoCameraIcon style={{ color: color, width: tablet ? "28px" : "20px", height: tablet ? "28px" : "20px" }} fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Fragment>
            )
        } else{
            return (
                <div>
                    <Typography
                        variant='body2'
                        style={{ color: color, fontWeight: fontWeight, fontSize: tablet ? "18px" : "14px" }}
                        className={`${classes.cell} `} 
                    >
                        {/* {value} */}
                        {cellProps.name.includes("dt") || cellProps.name.includes("Dt") || cellProps.name.includes("wazny")  ? val.slice(0, 16) : val}
                        {/* {cellProps.name.toLowerCase().includes('dt') ? value.split(" ")[0] : value} */}
                        {/* {String(value).includes(' ') ? String(value).split(' ')[0] : value} */}
                    </Typography>
                </div>
            )         
        }
 
    };

    headerRender = (value: string,) => {
        return (cellProps: CellProps) => {
            const { classes } = this.props;
            let hide = true

            if (cellProps.computedAbsoluteIndex == 0 || cellProps.name == "custom") {
                hide = false;
            }

            return (
                <div className={`${classes.tableHeadline}`} style={value == "" ? { height: "50px", marginLeft: "-4px", display: "flex" } : {}} onClick={() => { hide ? this.hideColumn((cellProps.name || "")) : this.showColumns() }}>
                    <p>
                        {/* {                       
                         value === "opis" 
                        ? <ArrowDropDownIcon style={{marginBottom: "-7px", marginLeft: "-6px"}}/> : null
                        }      */}
                        {value}
                    </p>
                </div>
            )
        }
    };

  

    hideColumn = (n: string) => {
        //let kolumny = this.state.ukryteKolumny
        //kolumny.push(n)
        //this.setState({ ukryteKolumny: kolumny })
    }

    showColumns = () => {
        this.setState({ ukryteKolumny: [] })
    }

    customCellStyle = (cellProps: CellProps) => {
        let style: React.CSSProperties = {}

        const borderlessColumns = ['data','opis', ]
        const greenBackground = ['lockAlias', 'doWyslaniaIlosc']
        const whiteBackground = ['dataOd', 'limitDzienUzytySuma','dataWplaty']

        if (cellProps.rowIndex === this.props.tableBody.length - 1)
            style = { ...style }
        if (borderlessColumns.includes(cellProps.name || ""))
            style = { ...style, borderLeft: 'none', padding: "8px 8px" }
        if (greenBackground.includes(cellProps.name || ""))
            style = { ...style, background: 'rgb(245, 255, 245)', padding: "8px 4px" }
        // if (whiteBackground.includes(cellProps.name || ""))
        //     style = { ...style, background: 'rgb(255, 255, 255)', padding: "8px 4px" }

        return style
    };

    selectStatus = async (cell: KarnetZjazdy) => {
        this.props.select(cell);
    };

    selectRow = async (row: any) =>{
        if(row.data){
            await this.selectStatus(row.data)
        }
    }

    render() {
        const { t, classes } = this.props;

        let tablet = this.props.page.tablet

        //console.log(this.props.tableBody)
        let columns : any[] = [
            // {
            //     name: 'OSTATNIA_STRONA', header: this.headerRender(''), maxWidth: 7.5, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
            //     headerProps: { style: { borderLeft: "0", height: '50px' }, className: `${classes.tableHeadline}` },
            //     onRender: (cellProps: any, { data }: any) => {
                    
                  
                        
            //     },
            //     style: this.customCellStyle,
            //     cellProps: { style: { padding: "0", } },
            // },
            {
                name: 'dt', header: this.headerRender("data"), defaultFlex: 3, minWidth: tablet ? 110 : 90, maxWidth: tablet ? 110 : 90, textAlign: 'left' as 'left', render: this.cellRender, draggable: false,
                headerProps: { style: {  height: '50px' }, className: `${classes.tableHeadline}` },
                style: this.customCellStyle,
            }, 
            {
                name: 'godzina', header: this.headerRender("godzina"), defaultFlex: 3, minWidth: tablet ? 70 : 55, maxWidth: tablet ? 70 : 55,  textAlign: 'left' as 'left', render: this.cellRender, draggable: false,
                headerProps: { style: {  height: '50px' }, className: `${classes.tableHeadline}` },
                style: this.customCellStyle,
            }, 
            {
                name: 'akcjaCzytnikOpis', header: this.headerRender("opis"), defaultFlex: 4, minWidth: 110,  textAlign: 'left' as 'left', render: this.cellRender, draggable: false,
                headerProps: { style: {  height: '50px' }, className: `${classes.tableHeadline}` },
                style: this.customCellStyle,
            },
           
           

           
            
        ];

        
            // columns.push(
            //     {
            //         name: 'dt', header: this.headerRender('dt'), defaultFlex: 1, minWidth: 120, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
            //         headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` },
            //         style: this.customCellStyle,
            //         cellProps: { style: { padding: "8px", } },
            //     },
            // )
        

        if (this.props.icon)
            columns.push(
                {
                    name: 'icon', header: this.headerRender('menu'), minWidth: tablet ? 50 : 40, maxWidth: tablet ? 50 : 40, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
                    headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` },
                    style: this.customCellStyle,
                    cellProps: { style: { padding: 0 } },
                }
            )

        // columns.push(
        //     {
        //         name: 'custom', header: this.headerRender(''), maxWidth: 7.5, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
        //         headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` }, onclick: this.showColumns,
        //         style: this.customCellStyle,
        //         cellProps: { style: { padding: 0 } },
        //     }
        // )


        //ukrycie klikniętych kolumn
        this.state.ukryteKolumny.forEach((nazwaKolumny: string) => {
            columns = columns.filter(col => col.name !== nazwaKolumny)
        })

        

        let dataBody = this.props.tableBody;

      

        const gridStyle = {
            minHeight:  dataBody.length * 50 + 1, borderTopWidth: "0px", fontSize: "12px"
            //, cursor: "pointer"
        };

        return (
            <>
               
                    <ReactDataGrid
                        columns={columns}
                        dataSource={dataBody}
                        showHeader={false}
                        
                        activeIndex={-1}

                        onRowClick={this.selectRow}
                        showZebraRows={this.props.page.lightMode ? true : false}
                        showColumnMenuTool={false}
                        sortable={false}
                        resizable={false}
                        showHoverRows={false}

                        style={gridStyle}
                        rowHeight={50}
                        headerHeight={45}
                    />
            </>
        );
    }
}

const styles = (theme: Theme) => ({
    cell: {
        fontSize: "14px"
    },
    tableHeadline: {
        color: "seagreen",
        fontWeight: 'bold' as 'bold',
        backgroundColor: "rgb(247, 247, 247)",
        fontFamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        fontSize: "0.875rem",
        minWidth: "7.5px",
        //margin: "auto",
        width: "-webkit-fill-available",
        cursor: "pointer"
    },
    margin: {
        margin: "auto"
    },
    preLine: {
        whiteSpace: 'pre-line' as 'pre-line'
    },
    breakAll: {
        wordBreak: 'break-all' as 'break-all'
    },
    padding1: {
        padding: '1px'
    },
    tooltip: {
        fontSize: "10px"
    },
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(TabelaZaplaty))); 

